export default function SelectionList({
  areas = [],
  totalAreaCount = 0,
  totalSkuCount = 0,
  onAddMore,
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-lg font-bold text-gray-900">Your Selection</h2>
        <button
          onClick={onAddMore}
          className="px-3 py-1.5 border border-gray-300 text-gray-700 text-xs font-semibold rounded-md hover:bg-gray-50 flex items-center gap-1.5 transition-colors"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add More Selection
        </button>
      </div>

      {/* Summary KPI Cards */}
      <div className="grid grid-cols-2 bg-gray-50 border border-gray-200 rounded-lg p-3 text-center mb-5 divide-x divide-gray-200">
        <div>
          <div className="text-xl font-bold text-gray-900">{totalAreaCount}</div>
          <div className="text-xs text-gray-500 font-medium">Total Area</div>
        </div>
        <div>
          <div className="text-xl font-bold text-gray-900">{totalSkuCount}</div>
          <div className="text-xs text-gray-500 font-medium">Total Product SKU</div>
        </div>
      </div>

      {/* Region List Items */}
      <div className="space-y-4">
        {areas.map((area, idx) => (
          <div
            key={area.id || idx}
            className="border border-gray-200 rounded-lg p-3 flex items-center gap-3 relative hover:border-gray-300 transition-colors"
          >
            <img
              src={area.image_url || "/placeholder-room.jpg"}
              alt={area.product_name || area.name}
              className="w-24 h-16 object-cover rounded-md flex-shrink-0 bg-gray-100"
            />
            <div className="flex-1 min-w-0">
              {/* Product Name */}
              <div className="text-sm font-semibold text-gray-900 truncate">
                {area.product_name || area.name || "N/A"}
              </div>

              {/* Product Size */}
              {area.product_size && (
                <p className="text-xs text-gray-500 mt-0.5">
                  Size: {area.product_size}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}